var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-container"},[(_vm.type == 1)?_c('img',{staticClass:"welcome-bg",attrs:{"src":require("../assets/img/welcome-new.png")}}):_c('img',{staticClass:"welcome-school-video",attrs:{"src":require("../assets/img/school-video.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }